import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { AppUser } from 'app/models/app-user';
// import 'rxjs/RX';
// import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { environment } from 'environments/environment';

@Injectable()
export class SsAuthService {
  // Auth root
  private ApiAuthBase = environment.API_BASE_URL + '/auth';
  private headers = new Headers();
  constructor(private http: Http) { }

  private handleError(error: any): Promise<any> {
    return Promise.reject(error.message || error);
  }

  login(userData): Observable<any> {
    // url
    const url = `${this.ApiAuthBase}/login`;
    // header params
    const headers = new Headers();
    const userParams = new FormData();
    userParams.append('email', userData.email);
    userParams.append('password', userData.password);
    userParams.append('client', 'WEB');
    // fire api request
    return this.http.post(url, userParams, { headers: headers })
      .map(res => res.json())
      .catch(this.handleError);
  }

  loginFacebook(user) {
    // url
    const url = `${this.ApiAuthBase}/Facebook`;
    // header params
    const headers = new Headers();
    const userParams = new FormData();
    userParams.append('first_name', user.first_name);
    userParams.append('last_name', user.last_name);
    userParams.append('fb_email', user.email);
    userParams.append('fb_uid', user.id);
    userParams.append('fb_access_token', user.token);
    userParams.append('fb_link', user.link);
    userParams.append('client', 'WEB');
    // fire api
    return this.http.post(url, userParams, { headers: headers }).map(res => res.json());
  }

  register(user: AppUser): Observable<any> {
    // url
    const url = `${this.ApiAuthBase}/register`;
    const userParams = new FormData();
    userParams.append('first_name', user.firstName);
    userParams.append('last_name', user.lastName);
    userParams.append('email', user.email);
    userParams.append('password', user.password);
    userParams.append('image', user.profImage);
    userParams.append('client', 'WEB');
    // fire api request
    return this.http.post(url, userParams, { headers: this.headers })
      .map(res => res.json())
      .catch(this.handleError);
  }

  isValidToken(token): Observable<any> {
    const url = `${this.ApiAuthBase}/validToken`;
    const headers = new Headers();
    const userParams = new FormData();
    userParams.append('token', token);
    headers.append('token', token);
    return this.http.post(url, userParams, { headers: headers }).map(res => res.json());
  }

  // SAVE NEW PASSWORD
  saveNewPassword(pass, uid) {
    const url = `${this.ApiAuthBase}/onboarding/email/passwordSave`;
    const headers = new Headers();
    const userParams = new FormData();
    userParams.append('password', pass);
    userParams.append('uid', uid);
    return this.http.post(url, userParams, { headers: headers }).map(res => res.json());
  }

  getTeamAuths(token) {
    const url = `${this.ApiAuthBase}/teams`;
    const headers = new Headers();
    headers.append('token', token);
    const userParams = new FormData();
    return this.http.post(url, userParams, { headers: headers }).map(res => {
      return res.json();
    })
      .catch(err => {
        console.log(err);
        return Observable.of(err.json());
      });
  }

  resendVerificationEmail(token) {
    const url = `${this.ApiAuthBase}/onboarding/email/resend`;
    const headers = new Headers();
    headers.append('token', token);
    const userParams = new FormData();
    userParams.append('token', token);
    return this.http.post(url, userParams, { headers: headers }).map(res => res.json());
  }

  verifyEmail(token, code) {
    const url = `${this.ApiAuthBase}/onboarding/email/verify`;
    const headers = new Headers();
    headers.append('token', token);
    const userParams = new FormData();
    userParams.append('email_code', code);
    return this.http.post(url, userParams, { headers: headers }).map(res => res.json());
  }

  // RESET PASSWORD
  sendPasswordResetLink(email) {
    const url = `${environment.API_BASE_URL}/onboarding/email/passwordResetEmail`;
    const headers = new Headers();
    const userParams = new FormData();
    userParams.append('email', email);
    return this.http.post(url, userParams, { headers: headers }).map(res => res.json())
      .catch(err => {
        return Observable.of(err.json());
      });
  }

  // Request info 
  requestGroupInfo(token, group_id, phone_number) {
    const url = `${environment.API_BASE_URL}/onboarding/groups/requestInfo`;
    const headers = new Headers();
    headers.append("token", token);
    const userParams = new FormData();
    userParams.append('group_id', group_id);
    userParams.append('phone_number', phone_number);
    return this.http.post(url, userParams, { headers: headers }).map(res => {
      console.log(res)
      return res.json()
    })
      .catch(err => {
        console.log(err)
        return Promise.reject(err);
      });
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/services/SS-Auth/ss-auth.service.ts